import { render } from "./ProductReviewSavePartial.vue?vue&type=template&id=8c1a3c94"
import script from "./ProductReviewSavePartial.vue?vue&type=script&lang=js"
export * from "./ProductReviewSavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script